import React from "react";
import ImgBackground from "../components/pngBackground/imageBackground";
import ContactUsImg from "../assets/images/contactUs.png";
import GetInTouch from "../components/getInTouchComponent/getInTouchComponent";
import "./styles.scss";
import TestimonialsTravala from "../components/testimonialsTravala/testimonialTravala";
import ConsultingContent from "../components/consultingComponents/consultingContent";
const ConsultingPage = () => {
  return (
    <div className="main-layout-container ">
      <ImgBackground insideText={"Consulting"} imgPath={ContactUsImg} />
      <ConsultingContent/>
      <GetInTouch />
      {/* <TestimonialsTravala /> */}
    </div>
  );
};

export default ConsultingPage;
